import {
  IBillingController,
  billingDataGetter,
  billingIntentSetupGetter,
  dataToGetIntentSetup,
  dataToGetBillingReport,
  dataToGetNewContactsPlans,
  dailyContactsPlansGetter,
  dataToGetProducts,
  productsGetter,
  dataToGetTokenUsage,
  tokenUsageGetter
} from '../domain/BillingController'

export default class BillingUseCase {
  static abort (controller: IBillingController): void {
    controller.abort()
  }

  static async getIntentSetup (
    controller: IBillingController,
    data: dataToGetIntentSetup
  ): Promise<billingIntentSetupGetter> {
    return await controller.getIntentSetup(data)
  }

  static async getBillingReport (
    controller: IBillingController,
    data: dataToGetBillingReport
  ): Promise<billingDataGetter> {
    return await controller.getBillingReport(data)
  }

  static async getNewDailyContactsPlans (controller: IBillingController, data: dataToGetNewContactsPlans): Promise<dailyContactsPlansGetter> {
    return await controller.getNewDailyContactsPlans(data)
  }

  static async getProducts (controller: IBillingController, data: dataToGetProducts): Promise<productsGetter> {
    return await controller.getProducts(data)
  }

  static async getTokenUsage (controller: IBillingController, data: dataToGetTokenUsage): Promise<tokenUsageGetter> {
    return await controller.getTokenUsage(data)
  }
}
